import React from "react";
import {
  Box,
  Divider,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  // DialogContentText,
  DialogActions,
  Stack,
  CircularProgress,
} from "@mui/material";
import { useDispatch } from "react-redux";
import {showLoadingScreen } from "../../store/slices/loading";

import DeleteIcon from "@mui/icons-material/Delete";
import { useSnackbar } from "notistack";
import { deletePersona } from "../../services/apiRequests";

const PersonModal = ({ isOpen, setOpen, personData,userApiKey, userData, setNeedRefreshData }) => {
	
	const [sendingRequest, setSendingRequest] = React.useState(false);
	const { enqueueSnackbar } = useSnackbar();
	const dispatch = useDispatch();
  const deleteHandler = () => {
	setSendingRequest(true)
	deletePersona(userApiKey, userData.id, personData.id).then(result => {
        enqueueSnackbar(result.mensaje, { variant: "success" });
		setOpen(false)
		dispatch(showLoadingScreen());
		setTimeout(setNeedRefreshData(), 500)
		setSendingRequest(false)
	})
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        setOpen(false);
      }}
    >
      <DialogTitle>Datos de Persona Censada</DialogTitle>
      <Divider />
      <DialogContent>
        {/* <DialogContentText> */}
          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
              sx={{ my: 1 }}
            >
              <Typography sx={{ pr: 12 }}>Nombre:</Typography>
              <Typography variant="h6" component="span">
                {personData !== null ? (
                  personData.nombre
                ) : (
                  <i>No especificado</i>
                )}
              </Typography>
            </Stack>
            <Divider />
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
              sx={{ my: 1 }}
            >
              <Typography sx={{ pr: 12 }}>F. Nacimiento</Typography>
              <Typography variant="h6" component="span">
                {personData !== null && personData.fechaNacimiento ? (
                  personData.fechaNacimiento.slice(8, 10) +
                  "/" +
                  personData.fechaNacimiento.slice(5, 7) +
                  "/" +
                  personData.fechaNacimiento.slice(0, 4)
                ) : (
                  <i>No especificado</i>
                )}
              </Typography>
            </Stack>
            <Divider />
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
              sx={{ my: 1 }}
            >
              <Typography sx={{ pr: 12 }}>Ocupación</Typography>
              <Typography variant="h6" component="span">
                {personData !== null && personData.ocupacion ? (
                  personData.ocupacion
                ) : (
                  <i>No especificado</i>
                )}
              </Typography>
            </Stack>
            <Divider />
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
              sx={{ my: 1 }}
            >
              <Typography sx={{ pr: 12 }}>Departamento:</Typography>
              <Typography variant="h6" component="span">
                {personData !== null && personData.departamento ? (
                  personData.departamento
                ) : (
                  <i>No especificado</i>
                )}
              </Typography>
            </Stack>
            <Divider />
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
              sx={{ my: 1 }}
            >
              <Typography sx={{ pr: 16 }}>Ciudad</Typography>
              <Typography variant="h6" component="span">
                {personData !== null && personData.ciudad ? (
                  personData.ciudad
                ) : (
                  <i>No especificado</i>
                )}
              </Typography>
            </Stack>
          </Box>
        {/* </DialogContentText> */}
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          onClick={deleteHandler}
          color="error"
          variant="contained"
          endIcon={<DeleteIcon />}
		  disabled={sendingRequest}
        >
		{(sendingRequest ? <CircularProgress size={20} sx={{color: "rgba(0, 0, 0, 0.5)"}} thickness={10} /> : "Eliminar")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PersonModal;
